// M10 — Manager-only tour: Workcenters. 4 steps on /workcenters.
export default {
  key: 'M10',
  route: '/workcenters',
  steps: [
    {
      id: 'groups',
      target: '[data-tour-id="workcenters.groups-tab"]',
      title: 'Workcenter Groups',
      desc: 'Each tab is a Workcenter Group — for example Cutting, Welding, Painting. Categories drive special behavior (Material, External, ...).',
    },
    {
      id: 'actions',
      target: '[data-tour-id="workcenter.actions"]',
      title: 'Workcenters & actions',
      desc: 'Inside a group, each workcenter shows the queue of actions to execute, sorted by priority.',
    },
    {
      id: 'status-priority',
      target: '[data-tour-id="workcenter.actions"]',
      title: 'Status & priority',
      desc: 'Use the row actions to change status (start, pause, complete), priority, or reassign to a different workcenter in the same group.',
    },
    {
      id: 'workers',
      target: '[data-tour-id="workcenter.actions"]',
      title: 'Worker assignment',
      desc: 'Click the worker icon on any row to assign which workers will execute that action. A worker can be assigned to multiple workcenters.',
    },
    {
      id: 'shopfloor-user',
      target: '[data-tour-id="workcenter.actions"]',
      title: 'Workers and the Shopfloor UI',
      desc: 'Workers don\'t sign in individually. Create one user with the ShopFloorWorker role (typically shopfloor@yourdomain) — anyone logging in with that account is redirected to the shared shopfloor screen, where workers identify themselves by barcode or by selecting their name.',
    },
  ],
}
